<template>
  <div class="TmBlockEdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; align-items: center">
            <el-input
              v-model="conf.borderWidth"
              controls-position="right"
              type="number"
              size="mini"
              @change="borderWidthChange"
              style="width: 49%"
              :placeholder="$t('lcd.Editor.Border Width')"
            ></el-input>
            <span>{{ $t("lcd.Editor.Border width explain") }}</span>
          </div>
        </attr-row>
        <attr-row
          :label="$t('lcd.Editor.Content Color')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <div
            v-if="!pageColor"
            style="display: flex; justify-content: space-between"
          >
            <div style="width: 49%; display: flex; align-items: center">
              <i
                class="icon iconfont icon-beijingse"
                style="font-size: 12px; margin: 0 6px 0 0; color: #000"
              ></i>
              <el-color-picker
                v-model="conf.bgColor"
                show-alpha
                :predefine="predefineColors"
                size="mini"
              />
              <i
                class="icon iconfont icon-biankuangse1"
                style="font-size: 12px; margin: 0 6px 0 12px; color: #000"
              ></i>
              <el-color-picker
                v-model="conf.borderColor"
                show-alpha
                :predefine="predefineColors"
                size="mini"
              />
            </div>
          </div>
          <!-- 价签填充色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBgColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
            <img
              @click="conf.bgColor = 'rgba(0,0,0,0)'"
              :src="transparentBg"
              style="width: 18px; height: 18px"
            />
          </div>
          <!-- 价签边框颜色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-biankuangse1"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBorderColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
          </div>
        </attr-row>

        <attr-row :label="$t('lcd.Editor.Border Radius')" :height="38">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.borderRadius.leftTop"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
            <el-input
              v-model="conf.borderRadius.rightTop"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
          </div>
          <div
            style="
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            "
          >
            <i
              class="icon iconfont icon-guanlian"
              :style="{
                fontWeight: '700',
                fontSize: '16px',
                color: conf.borderRadiusLock ? '#35b871' : '#e2e2e2',
              }"
            ></i>
            <!-- @click="changeBorderRadiusLock" -->
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.borderRadius.leftBottom"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
            <el-input
              v-model="conf.borderRadius.rightBottom"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 48%"
              @change="changeRadius"
            ></el-input>
          </div>
        </attr-row>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>
      </el-tab-pane>
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import ImageBox from "../../tumeng-Image/Image.vue";
import { predefineColors, colorList } from "../../../utils/constant.js";
import LogicDialog from "../../tumeng-display/src/index.vue";
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";

export default {
  name: "TumengBlockEdit",
  props: {
    goodsFields: {
      type: Array,
      default: [],
    },
  },
  components: {
    AttrRow,
    ImageBox,
    LogicDialog,
  },
  data() {
    return {
      predefineColors,
      transparentBg,
      colorList,
      state: store.state,
      localRadius: null,
      isMore: true,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  computed: {
    conf() {
      return store.state.activeComponent;
    },
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    clipShapObj() {
      return store.state.activeComponent.clipShap || {};
    },
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },

    borderWidthChange(e) {
      let confBW = +e;
      console.log("confBW", confBW);
      if (this.conf.height >= this.conf.width) {
        console.log(this.conf.width / 2);
        if (confBW > Math.floor(this.conf.width / 2)) {
          this.conf.borderWidth = Math.floor(this.conf.width / 2);
        }
      } else {
        console.log(this.conf.height / 2);
        if (confBW > Math.floor(this.conf.height / 2)) {
          this.conf.borderWidth = Math.floor(this.conf.height / 2);
        }
      }
    },

    changeRadius(data) {
      // console.log(data)
      const maxNum =
        this.conf.width > this.conf.height
          ? this.conf.height / 2
          : this.conf.width / 2;
      data = data > maxNum ? maxNum : data
      if (this.conf.borderRadiusLock) {
        this.conf.borderRadius.leftTop = data;
        this.conf.borderRadius.rightTop = data;
        this.conf.borderRadius.rightBottom = data;
        this.conf.borderRadius.leftBottom = data;
      }
    },

    changeBorderRadiusLock() {
      this.conf.borderRadiusLock = !this.conf.borderRadiusLock;
    },

    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },

    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },
    // 修改文本填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },
    // changeBorderColor
    changeBorderColor(index) {
      this.conf.borderColor = this.colorList[index].color;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.TmBlockEdit {
  margin: 8px;
  color: white;
  height: calc(100% - 16px);
  overflow: auto;
  .prop-pane {
    // 添加视频按钮变宽
    > button.el-button.el-button--default.el-button--small {
      width: 100%;
    }
    // 展示图片列表的div
    .img-item {
      margin: 0 12px 8px 4px;
      padding: 4px;
      border: 1px dashed white;
      width: calc(100% - 26px);
      height: 150px;
      text-align: left;
      position: relative;
      > img {
        float: left;
      }
      > div {
        float: left;
      }
      // 删除图片按钮
      > button.el-button.el-button--default.el-button--mini.is-circle {
        padding: 0;
        position: absolute;
        right: 0;
        top: 59px;
        transform: translate(5px, -50%);
      }
      // 让图片时长输入框和图片之间有个间距
      div.el-input-number {
        margin-top: 8px;
        text-align: left;
      }
      // 图片时长输入框的增加、减小按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }
      > div {
        // 图片时长输入框行高
        > span {
          display: inline-block;
          line-height: 28px;
          height: 28px;
          color: #000;
        }
      }
    }
  }
  .style-pane {
    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";

    .custom-smaller-slider-btn2 {
      // 旋转和透明度的slider的拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }
      // 旋转和透明度的slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }
      // 隐藏旋转和透明度数字输入框的增加、减少按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }
      // 让旋转和透明度的数字输入框便的正常
      ::v-deep input.el-input__inner {
        padding: 0;
      }
      // 指定旋转和透明度的输入框宽度宽度
      ::v-deep .el-input-number.el-input-number--mini {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
      .radius-box {
        ::v-deep .el-slider {
          width: 100%;
        }
        ::v-deep .el-slider__input {
          width: 60px;
        }
        ::v-deep .el-slider__runway.show-input {
          margin-right: 76px;
        }
        ::v-deep .el-slider__stop {
          display: none;
        }
        ::v-deep .el-slider__marks-text {
          margin-top: 5px;
        }
      }
    }
  }
}
// .lock{
//   position: absolute;
//   right: 0;
//   top: 8px;
//   font-size: 14px;
//   cursor: pointer;
// }

.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>
